// Environment helper to detect build/runtime context.
// - 'isDev' is true during development builds.
// - 'isTest' is true if:
//     a) running in development mode (locally), or
//     b) the hostname starts with "test." (used for preview/staging URLs)
// - The test for 'process.client' is used to safely access 'window.location' in the browser,
//   avoiding runtime errors during server-side rendering (SSR).

// useRequestHeaders() must be called lazily, inside a function scope.
// If it's evaluated too early (e.g., at module load time), it throws an error
// because the Nuxt app context may not be available yet.

// Don't use useLog() here!
// Because: useLog() uses useEnvironment(), so this would create circular calls

let cachedEnvironment = null;

function getHostname() {
  if (typeof window !== "undefined") return window.location.hostname;
  return process.env.HOSTNAME || ""; // server-side fallback if needed
}

export function useEnvironment() {
  if (cachedEnvironment) return cachedEnvironment;

  const isDev = process.env.NODE_ENV === "development";
  const hostname = getHostname();
  const isPreview = !isDev && (/vercel|localhost/.test(hostname) || !hostname);
  const isTest = !isDev && !isPreview && hostname.startsWith("test.");
  const isProduction = !isDev && !isTest && !isPreview;

  cachedEnvironment = {isDev, isPreview, isTest, isProduction};
  return cachedEnvironment;
}
